<template>
  <div ref="image" class="content-images">
    <div class="content-images-wrapper">
      <div v-for="(item, key) in pc" :key="key" class="content-images-item">
        <picture>
          <source media="(min-width: 750px)" :srcset="`${pc[key]} 3x`">
          <source media="(max-width: 750px)" :srcset="`${m[key]} 3x`">
          <img :src="pc[key]">
        </picture>
      </div>
    </div>
    <div v-if="pc.length > 1" class="swiper-button">
      <button ref="prev" type="button" class="swiper-button-prev"><icon-chevron-left /></button>
      <button ref="next" type="button" class="swiper-button-next"><icon-chevron-right /></button>
    </div>
  </div>
</template>

<script>
import Swiper, { Navigation, EffectFade } from 'swiper'
Swiper.use([Navigation, EffectFade])

export default {
  components: {
    iconChevronLeft: () => import('@/static/svg/chevron-left-big.svg'),
    iconChevronRight: () => import('@/static/svg/chevron-right-big.svg'),
  },
  props: {
    defaultImage: {
      type: String,
      default: ''
    },
    pc: {
      type: Array,
      default: () => []
    },
    m: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    setTimeout(this.setSlider, 300)
  },
  methods: {
    setSlider () {
      if (this.pc.length > 0) {
        // eslint-disable-next-line no-new
        new Swiper(this.$refs.image, {
          autoPlay: true,
          // observeParents: true,
          slideClass: 'content-images-item',
          wrapperClass: 'content-images-wrapper',
          loop: true,
          pagination: false,
          // simulateTouch: false,
          spaceBetween: 0,
          slidesPerView: 1,
          autoplay: true,
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        })
      }
    }
  }
}
</script>
